import type { ChatVariant } from "../ChatQueue/variants";
import type { ChatAlertBannerConfig } from "./types";

import { CircleIcon, ClockIcon, LogoutIcon, TriangleIcon } from "./icons";

export const chatAlertBannerConfig: Partial<Record<ChatVariant, ChatAlertBannerConfig>> = {
    inactive: {
        title: "The customer appears to be inactive.",
        description: "Hold off on replying until they respond to the bot.",
        showClose: true,
        color: "var(--mantine-color-dark-2)",
        icon: <ClockIcon />,
        closeButtonColor: "var(--mantine-color-dark-2)",
    },
    neglected: {
        title: "Neglect warning",
        description: "Respond as soon as possible.",
        showClose: true,
        color: "var(--mantine-color-error-9)",
        icon: <TriangleIcon />,
        closeButtonColor: "var(--mantine-color-dark-2)",
    },
    closedByCustomer: {
        title: "The customer has left the chat.",
        description: "It'll leave your queue shortly.",
        showClose: false,
        color: "var(--mantine-color-asurion-4)",
        icon: <LogoutIcon />,
    },
    customerDisconnected: {
        title: "This chat has been closed.",
        description: "It'll leave your queue shortly.",
        showClose: false,
        color: "var(--mantine-color-asurion-4)",
        icon: <LogoutIcon />,
    },
    transferredNeglected: {
        title: "The customer was neglected in the previous chat.",
        description: "Treat them with extra care.",
        showClose: true,
        color: "var(--mantine-color-warning-5)",
        icon: <CircleIcon />,
        closeButtonColor: "var(--mantine-color-warning-6)",
    },
};
